import { useCallback, useEffect, useState } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TSupplierDetails } from 'utils/types';

const useFetchSupplier = (enabled = true) => {
  const [suppliers, setSuppliers] = useState<TSupplierDetails[]>([]);

  const fetchSuppliers = useCallback(async () => {
    try {
      const res = await axiosInstance.get(
        `/api/v1/suppliers?page=1&pageSize=1000`
      );
      setSuppliers(res.data.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    fetchSuppliers();
  }, [enabled, fetchSuppliers]);

  return { suppliers };
};

export default useFetchSupplier;
